import { render, staticRenderFns } from "./SuccessSnackbar.vue?vue&type=template&id=18356fe5"
import script from "./SuccessSnackbar.vue?vue&type=script&lang=ts"
export * from "./SuccessSnackbar.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports